export { default } from './CheckInfoCard';
